import { CollisionDetection, pointerWithin } from '@dnd-kit/core';

export const SLIDE_LIBRARY_PANEL_DROP_ID = 'slide-library-panel';
export const SLIDE_LIBRARY_TAB_DROP_ID = 'slide-library-tab';

export function isSlideLibraryDropTarget(id: unknown): boolean {
  const value = String(id || '');
  return value === SLIDE_LIBRARY_PANEL_DROP_ID || value === SLIDE_LIBRARY_TAB_DROP_ID;
}

export const slideLibraryCollision: CollisionDetection = (args) => {
  const pointerHits = pointerWithin(args);
  if (!pointerHits.length) return [];
  const libraryHit = pointerHits.find((hit) => isSlideLibraryDropTarget(hit.id));
  return libraryHit ? [libraryHit] : pointerHits;
};

export function suggestedLibrarySlideName(deckName: string | undefined, slideIndex: number): string {
  const base = String(deckName || '').trim() || 'Presentation';
  return `${base} · sida ${slideIndex + 1}`;
}
